var global = require('../internals/global');
var defineGlobalProperty = require('../internals/define-global-property');

var SHARED = '__core-js_shared__';
var store = global[SHARED] || defineGlobalProperty(SHARED, {});

module.exports = store;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/shared-store.js
// module id = 310
// module chunks = 0